import { render, staticRenderFns } from "./context-color.vue?vue&type=template&id=680ed1db"
import script from "./context-color.vue?vue&type=script&lang=js"
export * from "./context-color.vue?vue&type=script&lang=js"
import style0 from "./context-color.vue?vue&type=style&index=0&id=680ed1db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports